export default "__VITE_ASSET__BmQP35yY__"